import createHubspot from './hubspot';

const create = api => ({
    hubspot: createHubspot(api),
});

export default {
    create,
};
